export const SHS_TOKEN_CONTRACT_ADDRESS = "0x13c79205e72a91c4adea3d552642f43e7a4f9a98bae3e2a579da05b1c8d1d6a8"
export const SHS_TOKEN_DECIMALS = 9

export const InfoStaking = {
    constract: "0x949c7a805e0d8e35cb678b245d0983967516e6f69cfa71ab1b5785c8d74aa9af",
    pool: "0x4da67c8b244e1402ebd1cbb97014d7f79a752d398a2a7b31a022f7e0d1d045f1",
    nft_type: "0x2d4bd7e964d3dd4fc6a92bd03094fad90180bed911b6eb2f42d95bd4e29526a2::bluemove_nft::BlueMoveNFT",
    token_type: SHS_TOKEN_CONTRACT_ADDRESS+"::suiheroes::SUIHEROES",
    token_decimals: SHS_TOKEN_DECIMALS
}

export const InfoCoinflip = {
    contract: '0xa49cbeaf91940728e2000a0438b763de0642e039596a618e0aef7ffff93ba5d6',
    wager_amount: [50, 100, 200, 500, 1000, 2000],
    pool: '0x0538ce14716fe1c7ee5b5087b1c33b590d7096d06fdf6d8cef325a81ae2d0196',
    token_type: SHS_TOKEN_CONTRACT_ADDRESS+'::suiheroes::SUIHEROES',
    token_decimals: SHS_TOKEN_DECIMALS
}

export const InfoDice = {
    contract: '0x9c3d7eabba05d87d0808ab6d95c23aa6ba1aa5c56a8835164c4d4501b76e8551',
    wager_amount: [50, 100, 200, 500, 1000, 2000],
    pool: '0x0073d2bcc72b46137c095d0c0ca48488f49c5ff4839b2e7518840bb885504a2f',
    token_type: SHS_TOKEN_CONTRACT_ADDRESS+"::suiheroes::SUIHEROES",
    token_decimals: SHS_TOKEN_DECIMALS
}